<template>
    <div class="tw:flex tw:items-center tw:gap-2 tw:text-sm">
        <span class="tw:text-gray-700 tw:font-bold tw:block">Por página:</span>
        <div class="tw:relative">
            <select
                :value="props.value"
                class="tw:border tw:border-gray-200 tw:rounded tw:px-3 tw:py-1 tw:bg-white tw:text-gray-600 tw:text-xs tw:appearance-none tw:pr-7 tw:cursor-pointer tw:transition-all tw:hover:border-gray-400 focus:tw:outline-none focus:tw:border-gray-400"
                aria-label="Elementos por página"
                @change="onChange"
            >
                <option
                    v-for="opt in props.options"
                    :key="opt.value"
                    :value="opt.value"
                >
                    {{ opt.label }}
                </option>
            </select>
            <!-- Chevron icon -->
            <div class="tw:absolute tw:right-2 tw:top-1/2 tw:-translate-y-1/2 tw:pointer-events-none tw:text-gray-400">
                <i class="material-icons tw:text-sm tw:leading-none">expand_more</i>
            </div>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        value: {
            type: Number,
            default: 10
        },
        options: {
            type: Array,
            default: () => [
                { value: 5,  label: '5' },
                { value: 10, label: '10' },
                { value: 15, label: '15' },
                { value: 20, label: '20' },
            ]
        }
    });

    const emit = defineEmits(['input', 'change']);

    function onChange(event) {
        const parsed = parseInt(event.target.value, 10);
        emit('input', parsed);
        emit('change', parsed);
    }
</script>
